import "~/misc/common";
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    console.log('initImagesForm');

    function readURL(input: HTMLInputElement) {
      if (input.files && input.files[0]) {
        const reader = new FileReader();
        reader.onload = function (e) {
          const result = e.target?.result;
          if (typeof result === "string") {
            $('#selectedImage').attr("src", result);
          }
        };
        reader.readAsDataURL(input.files[0]);
      }
    }
    $(".image_attributes_uri").on("change", (e) => {
      const input = e.currentTarget as HTMLInputElement;
      readURL(input);
      $('.destroy_image_checkbox').attr('value', 'false');
    });
    $('#destroy_image').on('click', function (e) {
      console.log('Destroy clicked');
      $('#selectedImage').attr('src', null);
      $('#selectedImage').attr('alt', null);
      $('.destroy_image_checkbox').attr('value', 'true');
      e.preventDefault();
      return true;
    });
  }
}